<template>
  <div class="messages-tabs">
    <div class="tabs-wrapper">
      <div>
        <router-link :to="{name: 'messages'}"
                     class="tab-title skip-tabs"
                     :class="{active: ['messages', 'messagesNew'].indexOf($route.name) !== -1 }"
        >Messages
        </router-link>
      </div>
      <div>
        <router-link :to="{name: 'outbox'}"
                     class="tab-title skip-tabs"
                     :class="{active: $route.name === 'outbox'}"
        >Outbox
        </router-link>
      </div>
      <div>
        <router-link :to="{name: 'lists'}"
                     class="tab-title skip-tabs"
                     :class="{active: $route.name === 'lists'}"
        >Lists
        </router-link>
      </div>
      <div>
        <router-link :to="{name: 'templates'}"
                     class="tab-title skip-tabs"
                     :class="{active: ['templates', 'templatesNew', 'templatesEdit'].indexOf($route.name) !== -1 }"
        >Templates
        </router-link>
      </div>

      <div v-if="!$root.checkFeature('messages_keywords')"
           class="not-allowed"
           v-tippy
           content="Upgrade to setup Keyword"
      >
        <a href="#" class="tab-title skip-tabs">Keyword</a>
      </div>
      <div v-else>
        <router-link :to="{name: 'keyword'}"
                     class="tab-title skip-tabs"
                     :class="{active: $route.name === 'keyword'}"
        >Keyword
        </router-link>
      </div>

      <div v-if="!$root.checkFeature('auto_messages')"
           class="not-allowed"
           v-tippy
           content="Upgrade to setup Auto Messages"
      >
        <a href="#" class="tab-title skip-tabs">Auto Messages</a>
      </div>
      <div v-else>
        <router-link :to="{name: 'AutoMessages'}"
                     class="tab-title skip-tabs"
                     :class="{active: ['AutoMessages', 'AutoMessagesEdit'].indexOf($route.name) !== -1}"
        >Auto Messages
        </router-link>
      </div>

      <tippy v-if="!$root.checkFeature('auto_messages')"
             to="msg-not-allowed"
             arrow>
        <div></div>
      </tippy>
    </div>

  </div>
</template>

<script>

  export default {
    name: 'MessagesMenu',
  };
</script>
